export default (baseCpdRoles, usedCpdRoles) =>
  baseCpdRoles.filter(
    (cpdRole) =>
      !usedCpdRoles.some(
        (usedRole) => usedRole && usedRole.role && usedRole.role.id === cpdRole.id,
      ),
  );
